var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"id\":5,\"omit\":1,\"remove\":true}!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-7ec213ff\",\"scoped\":true,\"hasInlineConfig\":true}!sass-loader!sass-resources-loader?{\"resources\":\"/Users/philmmoore/Development/CAT-UXO/cat-uxo-website-laravel/resources/sass/vue-globals.scss\"}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Advert.vue")
}
var normalizeComponent = require("!../../../node_modules/vue-loader/lib/component-normalizer")
/* script */
var __vue_script__ = require("!!babel-loader?{\"cacheDirectory\":true,\"presets\":[[\"env\",{\"modules\":false,\"targets\":{\"browsers\":[\"> 2%\"],\"uglify\":true}}]],\"plugins\":[\"transform-object-rest-spread\",[\"transform-runtime\",{\"polyfill\":false,\"helpers\":false}]]}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Advert.vue")
/* template */
var __vue_template__ = require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-7ec213ff\",\"hasScoped\":true,\"buble\":{\"transforms\":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Advert.vue")
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ec213ff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "resources/js/components/Advert.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ec213ff", Component.options)
  } else {
    hotAPI.reload("data-v-7ec213ff", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./resources/js/components/Advert.vue
// module id = ./resources/js/components/Advert.vue
// module chunks = 0 1